export enum ApiGenderCodeEnum {
    Female = 'V',
    Male = 'M',
    Neutral = 'N',
}
